interface FormSectionProps {
	title: string;
	/** A sentence under the title saying what the section is for. */
	description?: string;
	className?: string;
	children?: React.ReactNode | React.ReactNode[];
}

const FormSection = ({
	title,
	description,
	children,
	className,
}: FormSectionProps) => {
	return (
		<div className={`flex flex-col gap-4 ${className}`}>
			<div className="flex flex-col gap-1">
				<h2>{title}</h2>
				{description && (
					<p className="text-sm text-muted-foreground">{description}</p>
				)}
			</div>
			<div className="flex flex-col gap-8">{children}</div>
		</div>
	);
};

export default FormSection;
